import * as React from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { TApiInspectionPhoto } from '../../types/Inspection';
import { Divider } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import PhotoIcon from '@mui/icons-material/Photo';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filename: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
      overflow: 'hidden',
    },
  })
);

interface IInspectionPhotoListProps {
  photos: Array<TApiInspectionPhoto>;
  deleteUploadedPhoto: (photoId: number) => void;
}

const InspectionPhotoList: React.FC<IInspectionPhotoListProps> = ({
  photos,
  deleteUploadedPhoto,
}): JSX.Element => {
  const classes = useStyles({});
  return (
    <>
      <Divider />
      <List>
        {photos.map((photo: TApiInspectionPhoto, index: number) => {
          return (
            <ListItem key={index}>
              <ListItemAvatar>
                <Avatar>
                  <PhotoIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={photo.filename}
                className={classes.filename}
              />
              <ListItemSecondaryAction>
                <IconButton
                  edge='end'
                  aria-label='delete'
                  onClick={() => deleteUploadedPhoto(photo.id)}
                  size="large">
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
      <Divider />
    </>
  );
};

export default React.memo(InspectionPhotoList);

